import { switchcase } from '@sweetgreen/garnish';

import { useLocalizationContext } from '../context';
import type { DeliveryPreferenceType } from '../graphql/types';

export const usePreferencesText = (type: DeliveryPreferenceType): string => {
  const { t } = useLocalizationContext();

  return switchcase({
    LEAVE_AT_DOOR: t('delivery.preferences.leave-at-door'),
    DOOR: t('delivery.preferences.meet-at-door'),
    CURBSIDE: t('delivery.preferences.meet-outside'),
  })(t('delivery.preferences.leave-at-door'))(type);
};
